{
  "name": "38-Vicentino II (1555) Adaptive Meantone/JI",
  "description": "19 tones from Extended 1/4 Syntonic Comma Meantone (g♭-b♯) combined with another tuning of the same 19 notes, raised by 1/4 of a Syntonic Comma, to produce perfect fifths. An example of \"adaptive\" Rational Intonation, this tuning allows triads to be played with 2:3 fifths and 4:5 major thirds or 5:6 minor thirds.",
  "scale": [
    "5.37657235",
    "76.04899926",
    "81.42557166",
    "117.1078577",
    "122.4844301",
    "193.1568569",
    "198.5334293",
    "269.2058562",
    "274.5824286",
    "310.2647146",
    "315.641287",
    "386.3137139",
    "391.6902863",
    "462.3627131",
    "467.7392855",
    "503.4215715",
    "508.7981439",
    "579.4705708",
    "584.8471432",
    "620.5294292",
    "625.9060016",
    "696.5784285",
    "701.9550009",
    "772.6274277",
    "778.0040001",
    "813.6862861",
    "819.0628585",
    "889.7352854",
    "895.1118578",
    "965.7842847",
    "971.1608571",
    "1006.843143",
    "1012.219715",
    "1082.892142",
    "1088.268715",
    "1158.941142",
    "1164.317714",
    "2/1"
  ],
  "key_colors_mode": "manual",
  "short_description": "38-VicentinoII",
  "built_in_group": "Extended Meantone",
  "key_labels": "note_names",
  "note_names": [
    "c",
    "c",
    "c",
    "c",
    "d",
    "d",
    "d",
    "d",
    "d",
    "d",
    "e",
    "e",
    "e",
    "e",
    "e",
    "e",
    "f",
    "f",
    "f",
    "f",
    "g",
    "g",
    "g",
    "g",
    "g",
    "g",
    "a",
    "a",
    "a",
    "a",
    "a",
    "a",
    "b",
    "b",
    "b",
    "b",
    "b",
    "b"
  ],
  "note_colors": [
    "#ffbdbd",
    "#ffe5e5",
    "#dee2da",
    "#fffae5",
    "#d0d0d7",
    "#f8ffeb",
    "#ffffff",
    "#ffe5e5",
    "#dee2da",
    "#fffae5",
    "#d0d0d7",
    "#f8ffeb",
    "#ffffff",
    "#ffe5e5",
    "#dee2da",
    "#fffae5",
    "#ffffff",
    "#ffe5e5",
    "#dee2da",
    "#fffae5",
    "#d0d0d7",
    "#f8ffeb",
    "#ffffff",
    "#ffe5e5",
    "#dee2da",
    "#fffae5",
    "#d0d0d7",
    "#f8ffeb",
    "#ffffff",
    "#ffe5e5",
    "#dee2da",
    "#fffae5",
    "#d0d0d7",
    "#f8ffeb",
    "#ffffff",
    "#ffe5e5",
    "#dee2da",
    "#fffae5"
  ],
  "equivSteps": 38,
  "fundamental": 440,
  "reference_degree": 28,
  "center_degree": 0,
  "rSteps": 6,
  "drSteps": 5,
  "hexSize": 42,
  "rotation": -34.5
}
